import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { TollReportRowDto } from "@/api/dtos";
import type { TollReportRow } from "./_models/TollReport";
import { toTollReportRowFromDto } from "./_transformers/toTollReportRowFromDto";

/** The merged Toll export (GET /sandbox/toll-report) built by process-toll: { total, rows }. */
export const getTollReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTollReport: builder.query<TollReportRow[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<{ total: number; rows: TollReportRowDto[] }>(
            `${backendBase()}/sandbox/toll-report`,
            { headers: { Accept: "application/json" } },
          );
          const rows = res.data.rows.map((x) => toTollReportRowFromDto(x));
          return { data: rows };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: [{ type: ReportTags.TollReport, id: "LIST" }],
    }),
  }),
});

export const getTollReport = getTollReportApi.endpoints.getTollReport;
